import React, { createContext, useState, useEffect } from "react";
import socket from "../socket"; 

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    socket.on("receiveNotification", (notification) => {
      setNotifications((prev) => [notification, ...prev]);
      setUnreadCount((prev) => prev + 1);
    //   playBeepSound();
    });

    return () => {
      socket.off("receiveNotification");
    };
  }, []);

  const markAllAsRead = () => {
    setUnreadCount(0);
  };

  const playBeepSound = () => {
    const beep = new Audio("/sounds/1.mp3");
    beep.load();
    beep.play().catch((error) => {
      console.log("Audio play failed:", error);
    });
  };
  

  return (
    <NotificationContext.Provider value={{ notifications, unreadCount, markAllAsRead }}>
      {children}
    </NotificationContext.Provider>
  );
};
